module.exports = __webpack_public_path__ + "f0b8d2f007241e8ce24f45aaf2136bf2.png";